// extracted by mini-css-extract-plugin
module.exports = {"centered":"Spinner_centered__3TdAJ","spinner":"Spinner_spinner__3VQ06","small":"Spinner_small__Gh6Ls"};